import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Grid, Typography, withStyles, Button } from '@material-ui/core'
import moment from 'moment'
import { withTranslation } from 'react-i18next'
import { generateSelectedPartialLabel } from '../../Utils/PartialShiftHelper'
import { updateMobileOfferForm } from '../../../actions/mobileActions'
import { updateLoading } from '../../../actions';
import AvailableTimeOffRequest from '../../Utils/AvailableTimeOffRequest';
import { EmployeeDashboardMobileSidePanelStyles } from '../../../../styles/mobileStyles';
import { RequestTypes } from '../../../../Enums';
import { SliderPartialRequest } from '../../../components/SliderPartialRequest';

class PartialShift extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleChangePartial = (e, val) => {
        const { formData, updateMobileOfferForm } = this.props
        const isVTO = formData.managerSetting.type === RequestTypes.voluntaryTimeOff;

        let startDate, newStartDate, newEndDate;

        if (isVTO) {
            // For VTO, use the VTO period start/end dates
            startDate = moment.utc(formData.raw.timeOffStartDate);
            newStartDate = moment.utc(startDate).add(val[0], 'm');
            newEndDate = moment.utc(startDate).add(val[1], 'm');
        } else {
            // For other request types, use the shift start/end dates
            const shift = formData.shifts[0];
            startDate = moment.utc(shift.startDateTime);
            newStartDate = moment.utc(startDate).add(val[0], 'm');
            newEndDate = moment.utc(startDate).add(val[1], 'm');
        }

        // Check if the selected range is partial (not the full period)
        const vtoStartDate = isVTO ? moment.utc(formData.raw.timeOffStartDate) : null;
        const vtoEndDate = isVTO ? moment.utc(formData.raw.timeOffEndDate) : null;
        const isPartial = isVTO
            ? !(newStartDate.isSame(vtoStartDate) && newEndDate.isSame(vtoEndDate))
            : false;

        updateMobileOfferForm({
            ...formData,
            partialDates: {
                isPartial: isPartial,
                startDate: newStartDate,
                endDate: newEndDate,
            }
        })
    }

    render() {
        const { formData, classes, updateSidePanelView, handlePreviousView, sidePanelData, storeData, t } = this.props;
        const requestType = formData.managerSetting?.type || 0;
        const isVTO = requestType === RequestTypes.voluntaryTimeOff;

        // For VTO, create a pseudo-shift object with the VTO period dates
        const shift = isVTO
            ? { startDateTime: formData.raw.timeOffStartDate, endDateTime: formData.raw.timeOffEndDate, segments: [] }
            : formData.shifts[0];

        // Get affected shifts for VTO to display as visual indicators
        //const vtoAffectedShifts = isVTO ? (formData.raw.affectedShifts || []) : [];

        const selectedPartial = generateSelectedPartialLabel(shift, formData.partialDates.startDate, formData.partialDates.endDate, requestType)

        return (
            <div className={classes.viewContainer}>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant={'h5'} className={classes.viewHeader}>
                            {t('billboard.partialShiftOption')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ padding: '0 20px' }}>
                        <SliderPartialRequest
                            shifts={[shift]}
                            storeData={storeData}
                            requestType={requestType}
                            handleChange={this.handleChangePartial}
                            //employeeSchedule={vtoAffectedShifts}
                            color={isVTO ? '#006600' : undefined}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ backgroundColor: '#1a518a', color: '#FFF', textAlign: 'center', padding: '10px 0' }}>
                        {selectedPartial}
                    </Grid>
                    {!isVTO && (
                        <Grid item xs={12}>
                            <AvailableTimeOffRequest
                                timeOffRequest={sidePanelData.timeOffRequest}
                                error={sidePanelData.timeOffRequestError}
                            />
                        </Grid>
                    )}
                </Grid>
                <Grid container className={classes.bottomBar}>
                    <Grid item xs={6} style={{ padding: '5px' }}>
                        <Button fullWidth className={classes.secondaryButton} onClick={handlePreviousView}>
                            Back
                        </Button>
                    </Grid>
                    <Grid item xs={6} style={{ padding: '5px' }}>
                        {(requestType === RequestTypes.toCover || requestType === RequestTypes.shiftSwap) ? (
                            <Button fullWidth className={classes.primaryButton} onClick={() => updateSidePanelView('SendTo')}>
                                Next
                            </Button>
                        ) : (//Open shift or VTO
                            <Button fullWidth className={classes.primaryButton} onClick={() => updateSidePanelView('CommentToManager')}>
                                Next
                            </Button>)}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    storeData: state.data,
    formData: state.mobileOfferShiftForm,
    sidePanelData: state.sidePanelData,
    options: state.httpOptions,
});

const mapDispatchToProps = dispatch => ({
    updateMobileOfferForm: payload => dispatch(updateMobileOfferForm(payload)),
    updateLoading: payload => dispatch(updateLoading(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('employmentBillboard')(withStyles(EmployeeDashboardMobileSidePanelStyles)(PartialShift)));
